Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var coreComponentsBackdrop = require('../../../backdrop');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var styles = {"appear":"popup-sheet__appear_457ms","enter":"popup-sheet__enter_457ms","appearActive":"popup-sheet__appearActive_457ms","enterActive":"popup-sheet__enterActive_457ms","appearDone":"popup-sheet__appearDone_457ms","enterDone":"popup-sheet__enterDone_457ms","exit":"popup-sheet__exit_457ms","exitActive":"popup-sheet__exitActive_457ms","exitDone":"popup-sheet__exitDone_457ms"};
require('./index.css');

var PopupBackdrop = function (_a) {
    var opacity = _a.opacity, opacityTimeout = _a.opacityTimeout, style = _a.style, backdropProps = tslib.__rest(_a, ["opacity", "opacityTimeout", "style"]);
    return (React__default.default.createElement("div", { style: tslib.__assign({ opacity: opacity, transition: opacity === 1 ? "opacity ".concat(opacityTimeout, "ms ease-in-out") : '', position: 'relative' }, style) },
        React__default.default.createElement(coreComponentsBackdrop.Backdrop, tslib.__assign({ transitionClassNames: styles }, backdropProps))));
};

exports.PopupBackdrop = PopupBackdrop;
